import React, { useEffect, useState } from "react";
import "./cube.css";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const BoxScrollRotate = ({ datas }) => {
  useEffect(() => {
    import("gsap/ScrollTrigger").then(({ ScrollTrigger }) => {
      gsap.registerPlugin(ScrollTrigger);

      const box = document.getElementById("boxes");
      const scroller = document.getElementById("topScrool");

      if (box && scroller) {
        gsap.timeline({
          scrollTrigger: {
            trigger: box,
            scroller: scroller,
            start: "top center",
            end: "400%",
            scrub: 1,
            pin: true,
          },
        })
          .to(box, { rotateX: 90, duration: 1, ease: "power2.inOut" })
          .to(box, { rotateX: 180, duration: 1, ease: "power2.inOut" })
          .to(box, { rotateX: 270, duration: 1, ease: "power2.inOut" })
          .to(box, { rotateX: 360, duration: 1, ease: "power2.inOut" });
      }
    });

    return () => {
      ScrollTrigger.getAll().forEach((instance) => instance.kill());
    };
  }, []);

  return (
    <div className="cube-container">
      <div id="boxes" className="box">
        {datas?.map((v, i) => {
          return (
            <div
              key={i}
              className={`slide ${
                i == 0
                  ? "front"
                  : i == 1
                  ? "back"
                  : i == 2
                  ? "top"
                  : i == 3
                  ? "bottom"
                  : ""
              }`}
            >
              <div className="flex flex-col  cubetext">
                <h2>{v?.heading}</h2>
                <p className="text-white">{v?.description}</p>
              </div>
              <div className="flex items-center justify-start -mt-10  sm:hidden max-sm:hidden ">
                <p className="text-[170px] text-mute-grey">0{i + 1}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BoxScrollRotate;
